import React from "react";
import cn from "classnames";
import { BrokenImage } from "../Icons";
import { ImgFallback } from "../ImgFallback/ImgFallback";
import Text from "../Text/Text";
import styles from "./ArticleCard.module.scss";

export type ArticleCardProps = {
    author: string;
    category: string;
    categoryUrl: string;
    contentUrl: string;
    imgSrc: string;
    logoSrc?: string;
    onCardClick?: () => void;
    onCategoryClick?: () => void;
    sponsorId?: number;
    title: string;
} & React.HTMLProps<HTMLDivElement>

export const ArticleCard = (props: ArticleCardProps) => {
    const {
        author,
        category,
        categoryUrl,
        className,
        contentUrl,
        imgSrc,
        logoSrc,
        onCardClick,
        onCategoryClick,
        sponsorId,
        title,
        ...restProps
    } = props;
    return (
        <article className={cn(styles.wrapper, className)} {...restProps}>
            <a className={styles.content} href={contentUrl} onClick={onCardClick} data-testid="article-card__content">
                <div className={styles.imgWrap}>
                    <ImgFallback
                        alt={title}
                        fallbackSrc="https://assets.themuse.com/images/missing-company-hero.jpg"
                        loading="lazy"
                        src={imgSrc}
                    />
                </div>
                <div className={cn(styles.body, {
                    [styles['body--has-logo']]: !!logoSrc,
                })}>
                    {!!logoSrc && (
                        <div className={cn(styles.logo, {
                            [styles['logo--sponsor']]: !!sponsorId,
                        })}>
                            <ImgFallback
                                alt={author}
                                fallbackNode={<BrokenImage />}
                                height="60"
                                loading="lazy"
                                src={logoSrc}
                                width="60"
                            />
                        </div>
                    )}
                    <Text className={styles.author} htmlTag="p" textStyle="heading-5">
                        By <strong>{author}</strong>
                    </Text>
                    <Text className={styles.title} htmlTag="h3" textStyle="heading-4">{title}</Text>
                </div>
            </a>
            <footer className={styles.footer}>
                <Text
                    className={styles.category}
                    data-testid="article-card__category"
                    href={categoryUrl}
                    htmlTag="a"
                    onClick={onCategoryClick}
                    textStyle="button-text"
                >
                    {category}
                </Text>
            </footer>
        </article>
    );
};
